import _taggedTemplateLiteral from "/home/runner/work/is-eth-congested-website/is-eth-congested-website/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import styled from 'styled-components';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
var useStyles = makeStyles(function (_ref) {
  var palette = _ref.palette;
  return {
    title: {
      fontWeight: 500,
      color: palette.primary.contrastText
    }
  };
});
var Separator = styled.hr(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 30%;\n  margin-bottom: 48px;\n  ", "\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return "\n    border-color: ".concat(theme.palette.primary.contrastText, ";\n  ");
});

var Title = function Title(_ref3) {
  var _ref3$text = _ref3.text,
      text = _ref3$text === void 0 ? '' : _ref3$text;
  var classes = useStyles();
  return React.createElement(React.Fragment, null, React.createElement(Typography, {
    align: "center",
    className: classes.title,
    variant: "h4"
  }, text), React.createElement(Separator, null));
};

export default Title;